import React, { useState } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";
import BankAccountWarning from '../Helpers/Modal/WarningModal/BankAccountWarning.js'
import StripePaymentMethods from "../Helpers/Modal/Forms/StripePaymentMethods";

export default function BankAccounts(props) {
  const [team, setTeam] = useState(props.team)
  const [accounts, setAccounts] = useState(props.stripe_accounts)
  const [openModal, setOpenModal] = useState(false)
  const [saving, setSaving] = useState(false)
  const [selectedAccount, setSelectedAccount] = useState(0)
  const [modifiedAccount, setModifiedAccount] = useState(null)
  const [openModifyModal, setOpenModifyModal] = useState(false)

  const disconnectAccount = async () => {
    Alert.show('notice', 'Please wait while we disconnect your account')
    setSaving(true)

    try {
      await disconnectRoute(selectedAccount)
    } catch {
      Alert.show('error', 'Could not disconnect account, try again later')
      setSaving(false)
      return
    }

    Alert.show('notice', 'Account disconnected successfully')
    setSaving(false)
    setTimeout(() => window.location.reload(), 1500)
  }

  const disconnectRoute = (id) => {
    return HTTP.delete(`/settings/bankaccounts/${id}`)
  }

  const closeModifyModal = () => {
    setModifiedAccount(null)
    setOpenModifyModal(false)
  }

  const saveMethods = async (methods) => {
    setSaving(true)

    if (methods.includes('card')) {
      try {
        let reponse = await updateRoute({id: modifiedAccount.id, methods: methods})
        setTeam(reponse.data.team)
        setAccounts(reponse.data.accounts)
        Alert.show('notice', 'Account settings updated successfully')
        setSaving(false)
        closeModifyModal()
      } catch {
        Alert.show('error', 'Error uploading changes, please retry again')
        setSaving(false)
      }
    } else {
      Alert.show('error', 'There was an unexpected error, page will reload to solve automatically')
      setTimeout(() => window.location.reload(), 2000)
    }
  }

  const updateRoute = (data) => {
    return HTTP.patch('/settings/bankaccounts', data)
  }

  return (
    <div>
      <div className='card'>
        <div className='card-header flex-header'>
          <h4 className='card-title'>
            Bank Accounts
          </h4>

          <div className='btn-group'>
            <a className='btn btn-primary' href={props.stripe_helper}>+ Add Bank Account</a>
          </div>
        </div>
      </div>

      {team.stripe_uid &&
          <div className="card">
            <div className="card-header flex-header">
              <h4>Main Account</h4>
              <div className="btn-group">
              <button 
                className="btn btn-primary btn-sm mr-1" 
                onClick={() => {
                  setModifiedAccount({id: 0, methods: team.stripe_payment_methods})
                  setOpenModifyModal(true)
                }}
              >
                Modify
              </button>
                <button 
                  className="btn btn-danger btn-sm" 
                  disabled={accounts && accounts.length > 0}
                  onClick={() => {
                    setSelectedAccount(0)
                    setOpenModal(true)
                  }}
                >
                  Remove
                </button>
              </div>
            </div>
            <div className="card-body flex-body">
              <div>
                <p><b>Name: </b> {team.stripe_account_name}</p>
                <p><b>Provider: </b> Stripe Connect</p>
                <p><b>Account Type: </b> Standard</p>
                <p><b>Stripe ID: </b> {team.stripe_uid}</p>
              </div>
            </div>
          </div>
      }

      {accounts && accounts.length > 0 && accounts.map(account => (
        <div className="card">
          <div className="card-header flex-header">
            <h4>Other Account</h4>
            <div className="btn-group">
              <button 
                className="btn btn-primary btn-sm mr-1" 
                onClick={() => {
                  setModifiedAccount({id: account.id, methods: account.stripe_payment_methods})
                  setOpenModifyModal(true)
                }}
              >
                Modify
              </button>
              <button 
                className="btn btn-danger btn-sm" 
                onClick={() => {
                  setSelectedAccount(account.id)
                  setOpenModal(true)
                }}
              >
                Remove
              </button>
            </div>
          </div>
          <div className="card-body flex-body">
            <div>
              <p><b>Name: </b> {account.name}</p>
              <p><b>Provider: </b> Stripe Connect</p>
              <p><b>Account Type: </b> Standard</p>
              <p><b>Stripe ID: </b> {account.stripe_id}</p>
            </div>
          </div>
        </div>
      ))
      }

      {!team.stripe_uid &&
        <div className="card">
          <div className="card-body">
            0 accounts connected, you will not be able to collect payments until you connect an account
          </div>
        </div>
      }

      {openModal &&
        <BankAccountWarning 
          proceed={disconnectAccount} 
          cancel={() => {
            setOpenModal(false); 
            setSelectedAccount(0)
          }} 
          saving={ saving }
        />
      }

      {openModifyModal && 
        <StripePaymentMethods 
          close={closeModifyModal}
          account={modifiedAccount}
          proceed={(methods) => saveMethods(methods)}
          saving={saving}
        />
      }
    </div>
  )
}